import {FormControl, HStack, IconButton, Input, Text, VStack} from "@chakra-ui/react";
import {CheckIcon, EditIcon} from "@chakra-ui/icons";
import {useTranslations} from "next-intl";
import {FieldLabel} from "../ui/widget/FieldLabel";

export function HideableField(
    {value, onChange, isShown, onChangeVisibility, isRequired=false, label="", placeholder="", allowEdit=true}:
        {
            value: string,
            isRequired?: boolean,
            onChange: (val: string) => void,
            label?: string,
            placeholder?: string,
            isShown: boolean,
            allowEdit?: boolean,
            onChangeVisibility: (value: boolean) => void}
) {
    const t = useTranslations("addbar")
    return (
        <VStack w="100%">
            <FormControl isRequired={isRequired}>
                <FieldLabel text={label}/>
                {isShown ? (
                    <HStack>
                        <Input
                            key="input"
                            autoFocus={true}
                            placeholder={placeholder}
                            type="text"
                            onKeyDown={e=> {
                                if (e.key === 'Enter') {
                                    onChangeVisibility(false)
                                }
                            }}
                            value={value} onChange={(e) => onChange(e.target.value)}/>
                        <IconButton key="ok" variant="primary" icon={<CheckIcon/>} aria-label="ok" onClick={() => onChangeVisibility(false)}/>
                    </HStack>
                ) : (
                    <HStack align="center">
                        <Text size="sm">{value}</Text>
                        {allowEdit && (<IconButton icon={<EditIcon/>} variant="secondary" aria-label={t("edit")} onClick={() => onChangeVisibility(true)}/>)}
                    </HStack>
                )}
            </FormControl>
        </VStack>
    )
}